module.exports = __webpack_public_path__ + "static/media/ParentUpcomingEmpty.2232d22c.svg";